module.exports = __webpack_public_path__ + "static/media/cloud2.d8e0ef24.svg";